import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import type { Company } from '@/types';
    import CustomerDashboardContact from './CustomerDashboardContact.vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'CustomerDashboardContacts',
  props: {
    company: {}
  },
  setup(__props: any) {

    const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.company.primary_employee)
      ? (_openBlock(), _createBlock(CustomerDashboardContact, {
          key: 0,
          employee: _ctx.company.primary_employee
        }, null, 8, ["employee"]))
      : _createCommentVNode("", true),
    (_ctx.company.assistant)
      ? (_openBlock(), _createBlock(CustomerDashboardContact, {
          key: 1,
          employee: _ctx.company.assistant
        }, null, 8, ["employee"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})